import { render, staticRenderFns } from "./todosProcesos.vue?vue&type=template&id=09bd3406&scoped=true"
import script from "./todosProcesos.vue?vue&type=script&lang=js"
export * from "./todosProcesos.vue?vue&type=script&lang=js"
import style0 from "./todosProcesos.vue?vue&type=style&index=0&id=09bd3406&prod&lang=scss&scoped=true"
import style1 from "./todosProcesos.vue?vue&type=style&index=1&id=09bd3406&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd3406",
  null
  
)

export default component.exports